// Unpublished Work © 2022 Deere & Company

export const getCurrent = (govTaxIds, taxIdRow) => govTaxIds.find((govRow) => govRow.countryCode === taxIdRow.countryCode && govRow.taxIdType === taxIdRow.taxIdType);

export const validateHardRequired = (selectedTaxIdRows, govTaxIds) => {
    if (govTaxIds.length < 1) {
        return false;
    }

    return selectedTaxIdRows.every((row) => {
        const current = getCurrent(govTaxIds, row);

        return Boolean(current?.taxId !== '');
    });
};

export const validateSoftRequired = (selectedTaxIdRows, govTaxIds) => {
    if (govTaxIds.length < 1) {
        return false;
    }

    return selectedTaxIdRows.every((row) => {
        const current = getCurrent(govTaxIds, row);

        if (current === undefined) {
            return false;
        }
        return Boolean(current.taxId !== '' || current.taxId === null);
    });
};
